// Zweck: Monitoring-Status eines HubSpot-Projekts lesen.
// Kontext: Bestehender Monitoring-Endpunkt mit gezieltem Ops-M2M-Zugriff. Stand: 2026-10-08
import one360 from './one360';
import type { MonitoringStatus } from '../../interfaces/monitoring';

export async function getMonitoringStatus(dealId: string, signal: AbortSignal, refresh = false, cachedOnly = false): Promise<MonitoringStatus> {
  const status = await one360.get<MonitoringStatus>(`/api/v1/admin-portal/deals/${encodeURIComponent(dealId)}/monitoring`, {
    signal,
    params: { refresh, cachedOnly },
  });
  // Neue Provider-Werte bleiben sichtbar als unbekannt und lösen keine falsche Warnung aus.
  return {
    ...status,
    matchStatus: ['matched', 'unmatched', 'unavailable', 'ambiguous'].includes(status.matchStatus) ? status.matchStatus : 'unknown',
    registrationState: ['REGISTERED', 'CONSENT_PENDING', 'PENDING', 'CONSENT_REVOKED'].includes(status.registrationState) ? status.registrationState : 'UNKNOWN',
    apiAccess: ['confirmed', 'pending', 'revoked'].includes(status.apiAccess) ? status.apiAccess : 'unknown',
  };
}
